import { render, staticRenderFns } from "./DrivingLicense.vue?vue&type=template&id=8e7736d6"
import script from "./DrivingLicense.vue?vue&type=script&lang=ts"
export * from "./DrivingLicense.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports